import React from 'react';

function DarkFaqSupport(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43209'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43209)'>
        <path
          d='M40.2559 14.4614C40.3237 14.6091 40.3216 14.696 40.2559 14.884C40.1901 15.0721 38.2838 18.1637 37.8053 18.8585C37.4222 19.4155 36.545 19.3738 35.6763 19.4812L25.9964 29.1591L23.167 26.3311L32.8505 16.6575C33.001 15.6799 32.9565 14.9505 33.5184 14.5759C34.7391 13.7454 35.9103 12.9749 37.1706 12.2504C37.6194 12.0179 37.8286 11.991 38.2457 12.319C38.6902 12.6696 39.6473 13.6457 40.0184 14.0903C40.1173 14.209 40.188 14.3136 40.2559 14.4614Z'
          fill='#C299C5'
        />
        <path
          d='M13.3144 38.6991C11.5092 36.8939 11.2045 34.7161 12.4457 33.475L18.4961 27.8776C17.5405 27.1863 18.4198 25.8724 19.398 26.5544L25.4562 32.6084C26.1383 33.5831 24.8264 34.4659 24.1323 33.5096L18.5152 39.0518C17.2486 40.3184 14.9493 40.3333 13.3144 38.6991ZM18.9994 32.0125C17.3807 33.5046 16.5234 34.3429 14.9521 35.9142C14.34 36.5263 15.4667 37.6735 16.0894 37.0508L20.1359 33.0049C20.654 32.3886 19.627 31.3842 18.9994 32.0125Z'
          fill='#C299C5'
        />
        <path
          d='M39.8469 34.4355V35.3876C39.3189 37.7356 37.5554 35.1232 36.7418 34.7069L35.0376 36.3729C35.4066 37.2013 38.0911 38.9783 35.7197 39.5112C32.4245 39.8717 29.9492 36.6973 30.7211 33.5908L28.2354 31.0961L31.4253 27.9083L33.923 30.391C36.6188 29.7231 39.6108 31.546 39.8469 34.4355Z'
          fill='#C299C5'
        />
        <path
          d='M16.9267 12.4569C20.2092 12.0724 22.647 15.3005 21.8843 18.3625L24.611 21.099L21.4593 24.2868L18.6824 21.563C16.1308 22.1779 13.2992 20.6377 12.8349 17.9433C12.6935 17.1785 12.5592 15.4298 13.7863 15.6179C14.2711 15.726 15.3646 17.0025 15.8982 17.2478L17.5656 15.5451C16.9316 14.5873 14.5942 12.8521 16.9267 12.4569Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqSupport.displayName = 'DarkFaqSupport';

export default DarkFaqSupport;
